import * as formMapConfig from './reducers/map-config.reducer'
import * as fromGeo from './reducers/geo.reducer'
import * as fromAuth from './reducers/auth.reducer'
import {security} from './reducers/security.reducer';
import * as fromUsers from './reducers/users.reducer'
import * as fromAppUsers from './reducers/aux/user.reducer'
import * as fromMapFiles from './reducers/map-files.reducer'
import * as fromProviders from './reducers/provider.reducer'
import * as fromDatacenters from './reducers/datacenter.reducer'
import * as fromMarkets from './reducers/market.reducer'
import * as fromPolygons from './reducers/polygon.reducer'
import * as fromMap from './reducers/aux/map.reducer'
import * as fromSecurity from './reducers/security.reducer'
import * as fromAudit from './reducers/aux/audit.reducer'
import {ActionReducerMap, createFeatureSelector, createSelector} from "@ngrx/store";

export interface State {
  mapConfig: formMapConfig.State;
  geo: fromGeo.State,
  auth: fromAuth.State,
  users: fromUsers.State,
  mapFiles: fromMapFiles.State,
  providers: fromProviders.State,
  datacenters: fromDatacenters.State,
  markets: fromMarkets.State,
  polygons: fromPolygons.State
  map: fromMap.State
  appUsers: fromAppUsers.State
  security: fromSecurity.State
  audit: fromAudit.State
}

export const reducers: ActionReducerMap<State> = {
  mapConfig: formMapConfig.reducer,
  geo: fromGeo.reducer,
  auth: fromAuth.reducer,
  users: fromUsers.reducer,
  mapFiles: fromMapFiles.reducer,
  providers: fromProviders.reducer,
  datacenters: fromDatacenters.reducer,
  markets: fromMarkets.reducer,
  polygons: fromPolygons.reducer,
  map: fromMap.reducer,
  appUsers: fromAppUsers.reducer,
  security: fromSecurity.security,
  audit: fromAudit.reducer,
};

